import { getCalendlyInvitee } from './functions/calendly-invitee';
import { sendContactMessage } from './functions/contact-message';
import { getBlogPost, listBlogPosts } from './functions/content-blog';
import { getChangelogEntry, listChangelogEntries } from './functions/content-changelog';
import {
  getCompanyEmployee,
  listCompanyFounders,
  listCompanyInvestors,
} from './functions/content-company';
import {
  getCustomerStory,
  listCustomerLogos,
  listCustomerStories,
  listCustomerTestimonials,
} from './functions/content-customer';
import { getGlobalConfig } from './functions/content-global';
import { getPageContent, getPageContentBySlug } from './functions/content-pages';
import { listProductLanguages } from './functions/content-product';
import { sendSignupMessage } from './functions/signup';

/*
|------------------
| Types
|------------------
*/

export type {
  PageContentId,
  PageContentResult,
  PageContentResultBySlug,
} from './functions/content-pages';
export type {
  CustomerStory,
  CustomerLogo,
  CustomerTestimonial,
} from './functions/content-customer';
export type { ProductLanguage } from './functions/content-product';

/*
|------------------
| Default export
|------------------
*/

export default {
  sendContactMessage,
  sendSignupMessage,
  listBlogPosts,
  getBlogPost,
  getCalendlyInvitee,
  listCompanyFounders,
  listCompanyInvestors,
  getCompanyEmployee,
  getGlobalConfig,
  getPageContent,
  getPageContentBySlug,
  getChangelogEntry,
  listProductLanguages,
  listChangelogEntries,
  listCustomerLogos,
  listCustomerTestimonials,
  getCustomerStory,
  listCustomerStories,
};
